<template>
    <div>
        <WeightValidation ref="WeightValidation"></WeightValidation>
        <LoadingSpinner :busy="loading"></LoadingSpinner>
        <GenericPopups ref="GenericPopups"></GenericPopups>
        <PhotoWidget ref="PhotoWidget"></PhotoWidget>
        <b-card v-if="order && !loading">
            <template v-slot:header>
                <OrderCardHeader :order="order"></OrderCardHeader>
            </template>
            <b-card bg-variant="danger" text-variant="white" class="text-center" v-if="hasBeenShipped">
                <h2 class="text-center"><i class="fa-solid fa-exclamation-triangle fa-fw"></i> Shipment has been sent out</h2>
            </b-card>
            <b-card bg-variant="danger" text-variant="white" class="text-center" v-if="returnOfReturn">
                <h2 class="text-center"><i class="fa-solid fa-exclamation-triangle fa-fw"></i> Second Return</h2>
            </b-card>
            <b-row>
                <b-col cols="8">

                    <!--ORDER DETAILS - WEIGHTS-->
                    <b-row class="mb-3">
                        <b-col cols="8">

                            <!--order details-->
                            <b-card header="Order Details" class="header-sm h-100 mb-0">
                                <b-row>
                                    <b-col>

                                        <div class="label text-black-50"><i class="fa-light fa-home fa-fw"></i> Address</div>
                                        <div class="data">
                                            <div>{{ order.address.address1 }}, {{ order.address.address2 }}</div>
                                            <div>{{ order.address.city }}, {{ order.address.state }}
                                                {{ order.address.zip }}
                                            </div>
                                        </div>

                                        <div class="label text-black-50"><i class="fa-light fa-video fa-fw"></i> Intake Video
                                        </div>
                                        <div class="data">
                                            <div v-for="media in mediaIntakeVideo" :key="media.id">
                                                <b-button variant="link"
                                                          v-on:click="openProtectedMedia(media.type, media.file_path)">
                                                    Intake Video
                                                </b-button>
                                            </div>
                                        </div>

                                    </b-col>
                                    <b-col>

                                        <div class="label text-black-50"><i class="fa-light fa-box fa-fw"></i> Original
                                            Package Quality
                                        </div>
                                        <div class="data">{{ order.packing_quality | titleCase }}</div>

                                        <div class="label text-black-50"><i class="fa-light fa-dollar-sign fa-fw"></i> Return
                                            AV
                                        </div>
                                        <div class="data">${{ returnValue | toFixed2 }}</div>

                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-col>
                        <b-col cols="4">

                            <!--weights-->
                            <b-card header="Weights" class="header-sm h-100 mb-0">

                                <div class="label text-black-50"><i class="fa-light fa-weight"></i> Expected Weight</div>
                                <div class="data">{{ returnWeight | toFixed2 }}</div>

                                <div class="label text-black-50"><i class="fa-light fa-balance-scale"></i> Scale Weight</div>
                                <div class="data" :class="weightClass">
                                    <template v-if="manualItemsWeight">
                                        N/A
                                    </template>
                                    <template v-else>
                                        <ScaleWeight text-only v-on:scale-stable="scaleStable = $event"
                                                     v-on:scale-weight="scaleWeight = $event"
                                                     ref="scale"></ScaleWeight>
                                    </template>
                                    <span v-if="scaleVarianceError" class="text-danger"><i
                                        class="fa-solid fa-exclamation-triangle"></i> Weight Mismatch!</span>
                                </div>

                                <div class="label text-black-50"><i class="fa-light fa-weight"></i> Total Items Weight</div>
                                <div class="data">{{ manualItemsWeight ? manualItemsWeight : totalItemsWeight | toFixed2 }}
                                    <i class="fa-regular fa-edit fa-fw fa-sm pointer" @click="manualItemsWeightEditing = true" v-if="!manualItemsWeightEditing"></i>
                                </div>
                                <div v-if="manualItemsWeightEditing"><b-input size="sm" v-model.number="manualItemsWeight" class="d-inline" autofocus></b-input>
                                    <i class="fa-regular fa-save fa-fw fa-sm pointer" @click="saveManualWeight"></i>
                                    <i class="fa-regular fa-trash fa-fw fa-sm pointer" @click="manualItemsWeight = null;manualItemsWeightEditing = false;"></i>
                                </div>

                            </b-card>
                        </b-col>
                    </b-row>


                    <!--ALERTS AND BTN-->
                    <div class="returns-process mb-2 text-center">
                        <b-row class="text-center" v-if="globalState === 1">
                            <b-col cols="8">
                                <h5 v-if="returnOfReturn">Place package on scale.</h5>
                                <h5 v-else>Place items on scale together and check each item off.</h5>
                                <h5>Click Validate to continue.</h5>
                            </b-col>
                            <b-col cols="4" align-v="center">
                                <b-button
                                    block
                                    :disabled="!canValidate"
                                    variant="success"
                                    size="lg"
                                    @click="advanceGlobalState">
                                    <i class="fa-solid fa-check"></i> Validate
                                </b-button>
                            </b-col>
                        </b-row>
                        <b-row v-if="globalState === 2">
                            <b-col cols="8">
                                <h5>Weights Validated.</h5>
                                <span>Pack items and choose shipping options.</span>
                            </b-col>
                            <b-col cols="4" align-v="center">

                            </b-col>
                        </b-row>
                        <b-row v-if="globalState === 3">
                            <b-col cols="8">
                                <h5>Select Shipping Service</h5>
                                <span>Select a shipping service and then create label.</span>
                            </b-col>
                            <b-col cols="4" align-v="center">

                            </b-col>
                        </b-row>
                        <b-row v-if="globalState === 4">
                            <b-col cols="8" align-v="center">
                                <h5>Seal Package</h5>
                                <span>Seal package, then stop recording and save return.</span>
                            </b-col>
                            <b-col cols="4">
                                <b-button block variant="success" size="lg" @click="stopAndSave" :disabled="working"><i
                                    :class="isFinal ? 'fa-regular fa-spin fa-spinner' : 'fa-regular fa-stop-circle'"></i> Stop and Save
                                </b-button>
                            </b-col>
                        </b-row>
                    </div>


                    <!--PACKAGING WARNINGS-->
                    <template v-if="packagingAndCertificates">
                        <b-form-row>
                            <b-col cols="6">
                                <b-button block class="warning-btn" variant="warning" disabled><i
                                    class="fa-regular fa-exclamation-triangle"></i>&nbsp;PACKAGING MATERIAL
                                </b-button>
                            </b-col>
                            <b-col cols="6">
                                <b-button block class="warning-btn" variant="warning" disabled><i
                                    class="fa-regular fa-exclamation-triangle"></i>&nbsp;CERTIFICATE/PAPERS
                                </b-button>
                            </b-col>
                        </b-form-row>
                    </template>
                    <template v-else>
                        <b-row v-if="packaging">
                            <b-col>
                                <b-button block class="warning-btn" variant="warning" disabled><i
                                    class="fa-regular fa-exclamation-triangle"></i>&nbsp;PACKING MATERIAL
                                </b-button>
                            </b-col>
                        </b-row>
                        <b-row v-if="certificates">
                            <b-col>
                                <b-button block class="warning-btn" variant="warning" disabled><i
                                    class="fa-regular fa-exclamation-triangle"></i>&nbsp;CERTIFICATE/PAPERS
                                </b-button>
                            </b-col>
                        </b-row>
                    </template>


                    <!--INVENTORY-->
                    <b-row v-if="!returnOfReturn">
                        <b-col>
                            <b-table ref="inventoryTable" striped hover borderless outlined
                                     selectable
                                     tbody-tr-class="text-center"
                                     head-variant="dark"
                                     primary-key="order_id"
                                     :fields="fields"
                                     sticky-header
                                     :items="items"
                                     @row-selected="onRowSelected"
                                     :class="inventoryTableClass">
                                <template v-slot:head(on_scale)="row">
                                    On Scale?
                                    <b-button size="sm" variant="outline-light"
                                              :pressed.sync="_allSelected">
                                        <i class="fa-regular fa-check fa-fw"></i>
                                    </b-button>
                                </template>

                                <template v-slot:cell(picture)="data">
                                    <div @click.stop="activateImageModal(data.value)">
                                        <img class="table-img" :src="data.value" alt="">
                                    </div>
                                </template>


                                <template v-slot:cell(item_type)="data">
                                    {{ data.value }}
                                    <i class="fa-solid fa-archive fa-fw text-warning" v-if="data.item.box_and_papers === 'box' || data.item.box_and_papers === 'both'"></i>
                                    <i class="fa-solid fa-file-certificate fa-fw text-warning" v-if="data.item.certificate_type_id !== null && data.item.certificate_type_id !== 7"></i>
                                </template>

                                <template v-slot:cell(value)="data">
                                    ${{ data.value | toFixed2 }}
                                </template>

                                <template v-slot:cell(on_scale)="{ rowSelected }">
                                    <template v-if="rowSelected">
                                        <i class="fa-regular fa-check-square fa-fw"></i>
                                    </template>
                                    <template v-else>
                                        <i class="fa-regular fa-square fa-fw"></i>
                                    </template>
                                </template>

                            </b-table>
                        </b-col>
                    </b-row>

                </b-col>


                <!--VIDEO AND SHIPPING-->
                <b-col cols="4">
                    <video-streamer-control ref="video"  camera="overheadCamera" mode="video" auto-record video-type="return" :order-id="order.id"></video-streamer-control>

                    <b-card header="Create Shipment" class="header-sm mt-3" :class="shippingClass">

                        <!-- Calculate Shipping -->
                        <template v-if="globalState <= 2 && shippingType === 'default'">
                            <b-form-row>
                                <b-col cols="7">
                                    <b-form-group label-for="package-type">
                                        <slot name="label" for="package-type">
                                            <div class="label text-black-50"><i class="fa-light fa-box fa-fw"></i> Package
                                                Type
                                            </div>
                                        </slot>
                                        <b-input-group size="sm">
                                            <b-form-select v-model="returnPackaging.selected"
                                                           :options="returnPackaging.options"></b-form-select>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>

                                <b-col>
                                    <b-form-group>
                                        <slot name="label">
                                            <div class="label text-black-50"><i class="fa-light fa-weight fa-fw"></i> Package
                                                Weight
                                            </div>
                                        </slot>
                                        <b-input-group size="sm">
                                            <b-input-group-prepend>
                                                <b-button variant="outline-info"><i
                                                    class="fa-regular fa-balance-scale fa-lg"></i></b-button>
                                            </b-input-group-prepend>
                                            <b-form-input v-model.number="returnPackaging.weight"
                                                          :placeholder="returnPackaging.selected && returnPackaging.selected.weight ? returnPackaging.selected.weight.toString() : '0'"></b-form-input>
                                            <b-input-group-append>
                                                <b-dropdown :text="returnPackaging.weightType" size="sm">
                                                    <b-dropdown-item>oz</b-dropdown-item>
                                                    <b-dropdown-item>lb</b-dropdown-item>
                                                </b-dropdown>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-form-row>

                            <b-form-row>
                                <b-col cols="7">
                                    <b-form-group>
                                        <slot name="label">
                                            <div class="label text-black-50"><i class="fa-light fa-ruler-combined fa-fw"></i>
                                                Package
                                                Dimensions (W/L/H)
                                            </div>
                                        </slot>
                                        <b-row no-gutters>
                                            <b-col>
                                                <b-input-group size="sm">
                                                    <b-form-input v-model.number="returnPackaging.width"
                                                                  :placeholder="returnPackaging.selected && returnPackaging.selected.width ? returnPackaging.selected.width.toString() : 'Width'"></b-form-input>
                                                </b-input-group>

                                            </b-col>
                                            <b-col class="mx-1">
                                                <b-input-group size="sm">
                                                    <b-form-input v-model.number="returnPackaging.length"
                                                                  :placeholder="returnPackaging.selected && returnPackaging.selected.length ? returnPackaging.selected.length.toString() : 'Length'"></b-form-input>
                                                </b-input-group>
                                            </b-col>
                                            <b-col>
                                                <b-input-group size="sm">
                                                    <b-form-input v-model.number="returnPackaging.height"
                                                                  :placeholder="returnPackaging.selected && returnPackaging.selected.height ? returnPackaging.selected.height.toString() : 'Height'"></b-form-input>
                                                </b-input-group>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group>
                                        <slot name="label">
                                            <div class="label text-black-50"><i class="fa-light fa-signature fa-fw"></i>
                                                Signature Required
                                            </div>
                                        </slot>
                                        <b-input-group>
                                            <b-form-checkbox v-model="returnPackaging.signatureRequired"
                                                             name="check-button" switch v-b-tooltip.hover
                                                             :title="returnPackaging.signatureRequired ? 'Yes' : 'No'"
                                                             id="signature" :disabled="globalState !== 2">
                                            </b-form-checkbox>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-form-row>

                            <b-button-group class="d-flex">
                                <b-button variant="primary" size="lg"
                                          :disabled="calculateShippingDisabled"
                                          @click="getShippingSelections"><i class="fa-regular fa-calculator"></i>
                                    Calculate Final Postage
                                </b-button>
                                <b-dropdown right variant="primary" size="lg">
                                    <b-dropdown-item @click="shippingType = 'parcel-pro'"><i
                                        class="fa-regular fa-undo-alt"></i>
                                        Switch to Alternate Shipping Provider
                                    </b-dropdown-item>
                                </b-dropdown>
                            </b-button-group>
                        </template>

                        <!-- Shipping Options -->
                        <template v-if="globalState === 3">
                            <b-form-row>
                                <b-col v-if="shippingError">
                                    <b-alert show variant="danger"><h4 class="alert-heading">{{ shippingError.code }}</h4>{{ shippingError.text }}</b-alert>
                                </b-col>
                                <b-col v-else>
                                    <b-button block class="mb-3" size="lg" @click="globalState = 2" :disabled="working">
                                        <i class="fa-regular fa-edit"></i> Edit Package
                                        Details
                                    </b-button>
                                    <b-table striped hover
                                             selectable
                                             small
                                             select-mode="single"
                                             :items="shippingDetails.items"
                                             :fields="shippingDetails.fields"
                                             tbody-tr-class="text-center"
                                             head-variant="dark"
                                             selected-variant="primary"
                                             primary-key="item_id"
                                             @row-selected="onShippingRowSelected"
                                             tbody-class="font-sm"
                                             :busy="working">
                                        <template v-slot:table-busy>
                                            <LoadingSpinner :busy="working"/>
                                        </template>
                                        <template v-slot:cell(provider)="data">
                                            <img :src="data.item.provider_image_75">
                                            {{ data.value }}
                                        </template>
                                        <template v-slot:cell(service)="data">
                                            {{ data.item.servicelevel.name }}
                                        </template>
                                        <template v-slot:cell(delivery)="data">
                                            {{ data.item.estimated_days }} day(s)
                                        </template>
                                        <template v-slot:cell(cost)="data">
                                            ${{ data.item.amount | toFixed2 }}
                                        </template>
                                    </b-table>
                                    <b-button block variant="success" size="lg"
                                              :disabled="working || !shippingDetails.selected"
                                              @click="getShippingLabel">
                                        <i class="fa-duotone fa-spinner-third fa-spin"
                                           v-if="working && shippingDetails.selected"></i>
                                        <i class="fa-regular fa-barcode-alt" v-else></i>
                                        Create Shipping Label
                                    </b-button>
                                </b-col>
                            </b-form-row>
                        </template>


                        <template v-if="globalState === 4 && shippingType === 'default'">
                            <b-button block variant="primary" size="lg" @click="reprintLabel" :disabled="working">
                                <i class="fa-duotone fa-spinner-third fa-spin"
                                   v-if="working && shippingDetails.selected"></i><i
                                class="fa-regular fa-print" v-else></i> Re-print Shipping
                                Label
                            </b-button>
                        </template>


                        <template v-if="shippingType === 'parcel-pro'">
                            <template v-if="globalState === 4">
                                <div class="label text-black-50"><i class="fa-light fa-box fa-fw"></i> Alternate Tracking
                                    Number
                                </div>
                                <div class="data">{{ parcelProNumber }}</div>
                            </template>
                            <template v-else-if="globalState === 2">
                                <div class="label text-black-50"><i class="fa-light fa-box fa-fw"></i> Alternate Tracking
                                    Number
                                </div>
                                <b-form-group>
                                    <b-form-input v-model="parcelProNumber"
                                                  placeholder="Enter the alternate tracking number"></b-form-input>
                                </b-form-group>
                                <b-button-group class="d-flex">
                                    <b-button variant="success" size="lg"
                                              :disabled="parcelProNumber === '' || parcelProNumber === null"
                                              @click="processParcalPro()"><i class="fa-regular fa-check"></i> Save
                                    </b-button>
                                    <b-dropdown right variant="success" size="lg">
                                        <b-dropdown-item @click="shippingType = 'default'"><i
                                            class="fa-regular fa-undo-alt"></i>
                                            Switch to Standard Shipping
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </b-button-group>
                            </template>
                        </template>
                    </b-card>
                </b-col>
            </b-row>

        </b-card>

        <b-modal id="exit-modal" ok-only>
            <p>Your return has not been complete. Click the <strong>Stop and Save</strong> button to complete your return.</p>
        </b-modal>

    </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner';
import OrderCardHeader from '@/components/OrderCardHeader';
import VideoStreamerControl from '@/plugins/video-streamer/components/video-streamer-control';
import GenericPopups from '@/components/GenericPopups';
import _, {each, find, round} from 'lodash';
import WeightValidation from '@/components/WeightValidation';
import ScaleWeight from '@/components/ScaleWeight';
import PhotoWidget from '@/components/PhotoWidget';

export default {
    name: 'returns-index',
    components: {
        VideoStreamerControl,
        LoadingSpinner,
        OrderCardHeader,
        GenericPopups,
        WeightValidation,
        ScaleWeight,
        PhotoWidget,
    },
    data() {
        return {
            loading: false,
            working: false,
            isFinal: false,
            globalState: 1,
            shippingType: 'default',
            packagingAndCertificates: false,
            packaging: false,
            certificates: false,
            scaleStable: false,
            scaleWeight: null,
            scaleSaving: false,
            scaleSaved: false,
            scaleVarianceError: false,
            totalItemsWeight: 0,
            manualItemsWeight: null,
            manualItemsWeightEditing: false,
            parcelProNumber: null,
            shippoRateObjectID: null,
            shippoRateProvider: null,
            shippingError: null,
            labelData: null,
            order: null,
            previousReturn: false,
            previousReturnData: null,
            returnOfReturn: false,
            returnValue: 0,
            returnWeight: 0,
            returnTrackingNumber: null,
            returnTrackingUrl: null,
            returnTrackingLabelUrl: null,
            returnServiceProvider: null,
            returnPackaging: {
                selected: {template: null, width: 7.25, length: 11, height: 0.75, weight: .8,},
                options: [
                    {
                        label: 'Regular Mail',
                        options: [
                            {
                                value: {template: null, width: 7.25, length: 11, height: 0.75, weight: .8,},
                                text: 'Padded 7.25" X 11" Envelope'
                            },
                        ]
                    },
                    {
                        label: 'USPS Flat Rate',
                        options: [
                            {
                                value: {template: 'USPS_FlatRateEnvelope', width: 9.5, length: 12.5, height: 0.75, weight: 4.1,},
                                text: 'Flat Rate Envelope'
                            },
                            {
                                value: {template: 'USPS_SmallFlatRateBox', width: 5.44, length: 8.69, height: 1.75, weight: 3,},
                                text: 'Small Flat Rate Box'
                            },
                            {
                                value: {template: 'USPS_MediumFlatRateBox1', width: 8.75, length: 11.25, height: 6, weight: 4,},
                                text: 'Medium Flat Rate Box'
                            },
                            {
                                value: {template: 'USPS_LargeFlatRateBox', width: 12.25, length: 12.25, height: 6, weight: 11,},
                                text: 'Large Flat Rate Box'
                            },
                        ]
                    },
                    {
                        label: 'Other',
                        options: [
                            {
                                value: {template: null, width: null, length: null, height: null, weight: null,},
                                text: 'Other'
                            },
                        ]
                    },
                ],
                template: null,
                width: 7.25,
                length: 11,
                height: 0.75,
                weight: .8,
                weightRawDwt: null,
                weightType: 'oz',
                signatureRequired: true,
            },
            shippingDetails: {
                fields: [
                    {key: 'provider', label: 'Carrier', class: 'text-center'},
                    {key: 'service', class: 'text-center'},
                    {key: 'delivery', class: 'text-center'},
                    {key: 'cost', class: 'text-center'},
                ],
                items: [],
                selected: null,
            },
            fields: [
                {key: 'item_id', class: 'text-center', sortable: true},
                {key: 'picture', class: 'text-center', sortable: false},
                {key: 'item_type', class: 'text-center', sortable: true},
                {key: 'weight', class: 'text-center', sortable: false},
                {key: 'value', class: 'text-center', sortable: false},
                {key: 'on_scale', class: 'text-center', sortable: false},
            ],
            items: [],
            selected: [],
            allSelected: false,
        };
    },
    computed: {
        hasBeenShipped: function(){
            //shipping_status ENUM('pending', 'pulled', 'label-created', 'label-failed', 'shipped', 'delivered')
            return this.order.shipping_status == 'shipped' || this.order.shipping_status == 'delivered';
        },
        totalRows: function () {
            return this.items.length;
        },
        weightClass() {
            return [
                {'text-danger': this.scaleWeight === 0 && !this.scaleSaved},
                {'text-warning': !this.scaleStable},
                {'text-success': this.scaleStable && this.scaleWeight > 0},
            ];
        },
        shippingClass() {
            return {
                'psudo-disabled': this.globalState === 1,
                'transition': true,
            };
        },
        inventoryTableClass() {
            return {
                'psudo-disabled': this.globalState > 1,
                'transition': true,
            };
        },
        _allSelected:{
            set(val){
                if (val === true) {
                    this.selectAllRows();
                } else {
                    this.clearSelected();
                }
                this.allSelected = val;
            },
            get(){
                return this.allSelected;
            }
        },
        canValidate() {
            if ((this.allSelected || (this.returnOfReturn && (this.scaleWeight || this.manualItemsWeight))) && !this.manualItemsWeightEditing) {
                return true;
            } else {
                return false;
            }
        },
        mediaIntakeVideo: function(){
            return _.filter(this.order.media, function(e){
                return (e.type == 'video' /* && e.subtype == 'intake'*/); //fixme ADD SUBTYPE
            });
        },
        calculateShippingDisabled() {
            return (this.returnPackaging.selected === null || !this.returnPackaging.length || !this.returnPackaging.width || !this.returnPackaging.height  || !this.returnPackaging.weight);
        }
    },
    methods: {
        getData() {
            this.loading = true;
            this.working = true;
            this.scaleStable = false;
            this.scaleWeight = null;
            this.scaleSaving = false;
            this.scaleSaved = false;
            this.order = null;
            this.package = null;
            this.$http.get('/orders/' + this.$route.params.id + '/reverse-shipments')
                .then(response => {
                    console.log(response);
                    if(response.data[0] && response.data[0].order){
                        let data = response.data[0];

                        // Check for previous return
                        if (response.data[1] && response.data[1].order) {
                            this.previousReturn = true;
                            this.previousReturnData = response.data[1];

                            // Check for return of return
                            if (this.previousReturnData && find(this.previousReturnData.order.inventory_management, { 'list_name': 'return-of-returns', 'location_id': 7 })) {
                                this.returnOfReturn = true;
                                this.$bvModal.msgBoxConfirm('This order has already been returned.', {
                                    title: 'Second Return',
                                    okVariant: 'success',
                                    okTitle: 'Re-Print Label',
                                    centered: true,
                                    noCloseOnBackdrop: true,
                                    noCloseOnEsc: true,
                                }).then(value => {
                                    if (value === true) {
                                        this.returnWeight = round(this.convertWeightToDWT(this.previousReturnData.shipped_weight, this.previousReturnData.shipped_weight_unit), 1) || 0;
                                        // this.$nextTick(() => {
                                        //     this.$refs.video.startRecording();
                                        // });
                                    } else {
                                        this.$router.push({path: '/returns'});
                                    }
                                });
                            } else if(response.data[0].status != 'pending') { //return w/ no inventory management done before hand.
                                this.$bvModal.msgBoxConfirm('Order is already returned!', {
                                    title: 'Returned Order',
                                    okVariant: 'danger',
                                    okTitle: 'Ok',
                                    centered: true,
                                    noCloseOnBackdrop: true,
                                    noCloseOnEsc: true,
                                }).then(value => {
                                    this.$router.replace({path: '/returns'});
                                });
                            }
                        }

                        this.order = {
                            id: data.order.id,
                            customer: data.order.customer,
                            customer_id: data.order.customer.id,
                            status: data.order.status,
                            brand_id: data.order.brand_id,
                            full_name: data.order.customer.full_name,
                            address: {
                                address1: data.order.customer.address.address1,
                                address2: data.order.customer.address.address2,
                                city: data.order.customer.address.city,
                                state: data.order.customer.address.state,
                                zip: data.order.customer.address.zip
                            },
                            email: data.order.customer.email,
                            phone: data.order.customer.phone,
                            received_at: data.order.received_at,
                            flags: data.order.flags,
                            media: data.order.media,
                            notes: data.order.notes,
                            reverse_ship_id: data.id,
                            packing_quality: data.order.packing_quality,
                            shipping_status: data.status,
                        };
                        this.$store.commit('setActiveOrder', this.order);

                        if (this.order && this.order.flags && _.filter(this.order.flags, (f) => {return f.flag_type_id == 9 && f.cleared_at == null;}).length > 0) {
                            this.$bvModal.msgBoxConfirm('Order is Marked with Rescind Offer Flag. This flag must be cleared before we can return this order!', {
                                title: 'Rescind Offer Active',
                                okVariant: 'danger',
                                okTitle: 'Ok',
                                centered: true,
                                noCloseOnBackdrop: true,
                                noCloseOnEsc: true,
                            }).then(value => {
                                this.$router.replace({path: '/returns'});
                            });
                        }

                        each(data.inventory, item => {
                            this.items.push({
                                item_id: item.id,
                                picture: item.media[0].url,
                                item_type: item.type ? item.type.name : 'unknown',
                                value: item.appraisal.total,
                                weight: item.aggregate_dwt,
                                certificate_type_id: item.certificate_type_id,
                                box_and_papers: item.box_and_papers,
                                aggregate_dwt: item.aggregate_dwt,
                            });
                            this.returnValue += item.appraisal.total;
                            this.returnWeight += item.aggregate_dwt;

                            each(item.children, child => {
                                if (child.certificate_type_id !== null && child.certificate_type_id !== 7) {
                                    this.certificates = true;
                                }
                            });

                            if (item.box_and_papers === 'box' || item.box_and_papers === 'both' || _.filter(this.order.flags, (f) => {return f.flag_type_id == 26 && f.cleared_at == null;}).length > 0) {
                                this.packaging = true;
                            }
                            if (this.certificates && this.packaging) {
                                this.packagingAndCertificates = true;
                            }
                        });

                        // Alert if Order is Offer Accepted and there is no inventory
                        if((this.order.status.status === 'Offer Accepted' || this.order.status.status === 'Settled' || this.order.status.status === 'Batched')
                         && this.items.length === 0) {
                            this.$bvModal.msgBoxOk('Customer\'s offer is accepted. There is no inventory to return.', {
                                title: 'Invalid Return',
                                okVariant: 'danger',
                                okTitle: 'Ok',
                                centered: true,
                                noCloseOnBackdrop: true,
                                noCloseOnEsc: true,
                            });
                        } else if( this.items.length === 0) {
                            this.$bvModal.msgBoxOk('There is no inventory to return.', {
                                title: 'Invalid Return',
                                okVariant: 'danger',
                                okTitle: 'Ok',
                                centered: true,
                                noCloseOnBackdrop: true,
                                noCloseOnEsc: true,
                            });
                        }

                        // if (!this.returnOfReturn) {
                        //     this.$nextTick(() => {
                        //         this.$refs.video.startRecording();
                        //     });
                        // }

                        this.loading = false;
                        this.working = false;
                    } else{
                        this.$parent.$bvModal.msgBoxOk('Order '+ this.$route.params.id + ' does not contain a reverse shipment', {
                            title: 'Invalid Status',
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'danger',
                            headerClass: 'p-2 border-bottom-0 text-center d-block',
                            footerClass: 'p-2 border-top-0',
                        });
                        this.$router.replace({path: '/returns'});
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status === 404) {
                    }
                    this.$router.replace({path: '/returns/not-found/' + this.$route.params.id});
                });
        },
        saveManualWeight() {

            if (!this.$store.getters.hasPermission("manage inventory")) {
                this.$refs.GenericPopups.displayPermission =
                    {
                        title: 'Manual Override Weight',
                        text: 'You do not have permission to override weights.',
                        permission: 'manage inventory',
                        okAction: () => {
                            //note manager override was done. weights forced validation
                            this.manualItemsWeightEditing = false
                        },
                        cancel: 'ok',
                        ok: 'Manager override',
                        endPointsLater: ['/reverse-shipments/']
                    };
            } else {
                this.manualItemsWeightEditing = false;
            }
        },
        getShippingSelections() {
            this.advanceGlobalState();
            this.working = true;
            this.$http.post('/shippo/get-rates', {
                to_address: {
                    name: this.order.full_name,
                    street1: this.order.address.address1,
                    street2: this.order.address.address2,
                    city: this.order.address.city,
                    state: this.order.address.state,
                    zip: this.order.address.zip,
                    country: 'US',
                    phone: this.order.phone,
                    email: this.order.email,
                },
                parcel: {
                    template: this.returnPackaging.template,
                    length: this.returnPackaging.length,
                    width: this.returnPackaging.width,
                    height: this.returnPackaging.height,
                    distance_unit: 'in',
                    weight: round(this.calculateShippedWeight(), 4),
                    mass_unit: this.returnPackaging.weightType,
                },
                signature: this.returnPackaging.signatureRequired,
                order_id: this.order.id,
            })
                .then(response => {
                    if (response.data.is_valid === false) {
                        this.$bvToast.toast('Address validation failed. No rates returned.', {
                            title: 'Address Validation Failed',
                            variant: 'danger',
                            appendToast: true,
                            autoHideDelay: 3000,
                        });
                        this.shippingError = response.data.messages[0];
                        this.working = false;
                    } else {
                        this.shippingDetails.items = response.data;
                        this.working = false;
                    }

                });
        },
        getShippingLabel() {
            this.working = true;
            this.$http.post('/shippo/create-label', {
                rate_object_id: this.shippoRateObjectID,
                signature: this.returnPackaging.signatureRequired,
            })
                .then(response => {
                    console.log(response);
                    this.labelData = atob(response.data.label_data);
                    this.returnTrackingNumber = response.data.tracking_number;
                    this.returnTrackingUrl = response.data.tracking_url_provider;
                    this.returnTrackingLabelUrl = response.data.label_url;
                    this.returnServiceProvider = this.shippoRateProvider;

                    this.$printer.printRaw('usps', this.labelData).then(() => {
                        this.advanceGlobalState();
                        this.working = false;
                    }).catch(() => {
                        this.working = false;
                    });

                });
        },
        reprintLabel() {
            this.working = true;
            this.$printer.printRaw('usps', this.labelData).finally(() => {
                this.working = false;
            });
        },
        onRowSelected(selected) {
            if(selected.length == this.items.length){
                this.allSelected = true;
            } else {
                this.allSelected = false;
            }
            this.selected = selected;
        },
        onShippingRowSelected(items) {
            this.shippingDetails.selected = items.length !== 0;
            this.shippoRateObjectID = items[0].object_id;
            this.shippoRateProvider = items[0].provider;
        },
        selectAllRows() {
            this.$refs.inventoryTable.selectAllRows();
        },
        clearSelected() {
            this.$refs.inventoryTable.clearSelected();
        },
        // weightDisplay() {
        //     if (!this.$qz.connected) {
        //         //return 'ERR';
        //     }
        //     return this.scaleWeight.toFixed(1);
        // },
        convertItemWeightToUnit(unit) {
            if (unit === 'oz' && this.totalItemsWeight > 0) {
                return this.totalItemsWeight / 18.229;
            }
            if (unit === 'lb' && this.totalItemsWeight > 0) {
                return this.totalItemsWeight / 292;
            }
            return 0;
        },
        convertWeightToDWT(weight, unit) {
            if (unit === 'oz') {
                return weight * 18.229;
            }
            if (unit === 'lb') {
                return weight * 292;
            }
        },
        calculateShippedWeight() {
            if (this.returnOfReturn) {
                return this.convertItemWeightToUnit(this.returnPackaging.weightType);
            } else {
                return this.returnPackaging.weight + this.convertItemWeightToUnit(this.returnPackaging.weightType);
            }
        },
        advanceGlobalState(state) {
            this.validateGlobalStateChange(() => {
                if (state && Number.isInteger(state)) {
                    this.globalState = state;
                } else {
                    this.globalState++;
                }
                this.working = false;
            });
        },
        processParcalPro() {
            this.advanceGlobalState(4);
            this.returnTrackingNumber = this.parcelProNumber;
        },
        validateGlobalStateChange(onSuccess) {
            switch (this.globalState) {
                case 1:

                    if (this.returnOfReturn) {
                        if (this.manualItemsWeight) {
                            this.totalItemsWeight = this.manualItemsWeight;
                        } else {
                            this.totalItemsWeight = this.scaleWeight;
                        }

                        return this.$refs.WeightValidation.WeightValidationReturns(this.totalItemsWeight, this.returnWeight,
                            () => {
                                this.scaleVarianceError = true;
                            },
                            () => {
                                this.scaleVarianceError = false;
                                onSuccess();
                            });
                    } else {
                        if (this.manualItemsWeight) {
                            this.totalItemsWeight = this.manualItemsWeight;
                        }

                        return this.$refs.WeightValidation.WeightValidationReturns(this.totalItemsWeight, this.items,
                            () => {
                                this.scaleVarianceError = true;
                            },
                            () => {
                                this.scaleVarianceError = false;
                                onSuccess();
                            });
                    }

                default:
                    onSuccess();
            }
        },
        stopAndSave() {
            if (this.scaleWeight > 0) {
                this.$bvModal.msgBoxConfirm('Scale currently registers with weight. Do you wish to stop the video now?', {
                    title: 'Please Confirm',
                    okVariant: 'danger',
                    okTitle: 'Stop Video',
                    cancelTitle: 'Continue',
                    hideHeaderClose: true,
                    noCloseOnBackdrop: true,
                    noCloseOnEsc: true,
                    centered: true
                })
                    .then(value => {
                        if (value === true) {
                            this.saveProcessedReturn();
                        } else {
                            return false;
                        }
                    })
                    .catch(err => {
                        this.$bvToast(err);
                    });
            } else {
                this.saveProcessedReturn();
            }
        },
        saveProcessedReturn() {
            this.$refs.video.stopRecording();

            //do media method maybe, could maybe get by with a URL.
            this.isFinal = true;
            let send = {
                return_tracking_number: this.returnTrackingNumber,
                return_tracking_url: this.returnTrackingUrl,
                return_label_url: this.returnTrackingLabelUrl,
                service_provider: this.returnServiceProvider,
                shipped_weight: round(this.calculateShippedWeight(), 2),
                shipped_weight_unit: this.returnPackaging.weightType,
                shipped_packaging_weight: round(this.returnPackaging.weight, 2),
                signature: this.returnPackaging.signatureRequired,
            };
            this.$http.post('/reverse-shipments/' + this.order.reverse_ship_id + '/finish',send).then((e)=>{
                this.$router.push({path: '/returns'});
            });
        },

        activateImageModal(item){
            this.$refs.PhotoWidget.renderImage(item);
        },
        activateVideoModal(item){
            this.$refs.PhotoWidget.renderVideo(item);
        },

        exitPageModal() {
            if(this.globalState == 4 && this.isFinal == false) {
                this.$bvModal.show('exit-modal');
            }
        },

        openLightBox(media) {
            this.$refs.ImageLightBox.showLightBox(media);
        },

        openProtectedMedia (type, path) {
            this.$http.get('/media/getSignedUrl/byPath', {
                params: {path: path}
            })
                .then(response => {
                    if (type === 'photo') {
                        this.activateImageModal(response.data);
                    } else if (type === 'video') {
                        this.activateVideoModal(response.data);
                    }
                })
                .catch(() => {
                    return null;
                });
        },

    },
    watch: {
        'returnPackaging.selected'(val) {
            val && val.template ? this.returnPackaging.template = val.template : this.returnPackaging.template = null;
            val && val.width ? this.returnPackaging.width = val.width : this.returnPackaging.width = null;
            val && val.length ? this.returnPackaging.length = val.length : this.returnPackaging.length = null;
            val && val.height ? this.returnPackaging.height = val.height : this.returnPackaging.height = null;
            val && val.weight ? this.returnPackaging.weight = val.weight : this.returnPackaging.weight = null;
        },
        'allSelected'(value) {
            if (value === true) {
                this.totalItemsWeight = this.scaleWeight;
            } else {
                this.totalItemsWeight = 0;
            }
        },
        'scaleStable'(value){
            if(value && this.allSelected) {
                this.totalItemsWeight = this.scaleWeight;
            }
        },
        'totalItemsWeight' (value, oldValue) {
            if (value !== oldValue && !this.manualItemsWeight) {
                this.scaleVarianceError = false;
            }
        },
        'manualItemsWeight' (value, oldValue) {
            if (value !== oldValue) {
                this.scaleVarianceError = false;
            }
        },
        $route: {
            //immediate: true,
            //deep: true,
            handler(to, from){
                console.log(to.name);
                if (to.name.includes('returns-view')) {
                    this.getData();
                }
            }
        },
    },
    created() {
        this.getData();

        this.$qz.connect().then(() => {
            this.$scale.connect((weight, settled) => {
                this.scaleStable = settled;
                this.scaleWeight = weight;
            });
        });
        document.querySelector('.app-header').addEventListener('mouseenter', this.exitPageModal );
        document.querySelector('.sidebar').addEventListener('mouseenter', this.exitPageModal );
    },
    mounted() {
        this.$barcodeScanner.destroy();
    },
    beforeDestroy() {
        document.querySelector('.app-header').removeEventListener('mouseenter', this.exitPageModal );
        document.querySelector('.sidebar').removeEventListener('mouseenter', this.exitPageModal );
        this.$scale.disconnect().finally(() => {
            this.$qz.disconnect();
        });
    },
};
</script>

<style scoped>
    .b-table-sticky-header {
        border-bottom: 1px solid #ddd;
        max-height: 500px !important;
    }
    .psudo-disabled {
        opacity: 0.3;
        pointer-events: none;
    }

    .table-img {
        max-width: 100px;
    }
</style>
